export default __webpack_public_path__ + "static/media/12b.b149c6a5.jpg";